import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center items-center bg-gray-300 absolute top-0 right-0 left-0 bottom-0"
}
const _hoisted_2 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.type === _ctx.LoaderTypeEnum.SPINNER)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.finalClasses)
            }, null, 2))
          : (_ctx.type === _ctx.LoaderTypeEnum.BOUNCE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.finalClasses, "animate-bounce"])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.finalClasses, "animate-bounce200"])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.finalClasses, "animate-bounce400"])
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}